'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Button;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = require('./styles');

var _colors = require('../styles/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Button(props) {
  var classes = (0, _classnames2.default)((0, _styles.button)(props.color).toString(), props.className);
  return _react2.default.createElement(
    'button',
    {
      className: classes,
      onClick: function onClick(e) {
        props.onClick(e);
        if ('vibrate' in navigator) {
          navigator.vibrate(50);
        }
      },
      type: props.type,
      disabled: props.disabled
    },
    _react2.default.createElement(
      'div',
      { className: _styles.contentContainer },
      props.children ? props.children : props.text ? props.text : ''
    )
  );
}

Button.propTypes = {
  color: _propTypes2.default.string,
  text: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  type: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.element), _propTypes2.default.element, _propTypes2.default.string])
};

Button.defaultProps = {
  color: _colors.COLORS.BLUE,
  className: null,
  onClick: function onClick() {},
  disabled: false,
  type: 'button',
  text: null,
  children: null
};


//////////////////
// WEBPACK FOOTER
// ./~/tanda-components/Button/index.js
// module id = 1574
// module chunks = 0